import React, { useState,useEffect } from "react";
import ReactQuill, { Quill } from "react-quill";
import ImageResize from "quill-image-resize-module-react";
import {ImageExtend } from "quill-image-extend-module-cc";
import "react-quill/dist/quill.snow.css";
import { Box } from "@mui/material";

// Add sizes to whitelist and register them
const Size = Quill.import("formats/size");
Size.whitelist = ["extra-small", "small", "medium", "large"];
Quill.register(Size, true);
Quill.register("modules/imageResize", ImageResize);
Quill.register("modules/ImageExtend", ImageExtend);

// Add fonts to whitelist and register them
const Font = Quill.import("formats/font");
Font.whitelist = ["arial", "comic-sans", "courier-new", "georgia", "helvetica", "lucida"];
Quill.register(Font, true);


const QuillEditor = ({ placeholder,value,onChange  }) => {
    const [editorHtml, setEditorHtml] = useState(value || "");
    useEffect(() => {
      setEditorHtml(value);
    }, [value]);
  
    const handleChange = (html) => {
      setEditorHtml(html);
      if (onChange) {
        onChange(html);
      }
    };
  

    const modules = {
      toolbar: [
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ["bold", "italic", "underline", "strike", "blockquote", "code-block"],
        [
          { color: [] },
          { background: [] },
          { list: "ordered" },
          { list: "bullet" },
          { indent: "-1" },
          { indent: "+1" },
        ],
        [
          { align: "left" },
          { align: "center" },
          { align: "right" },
          { align: "justify" }
        ],
        ["link", "image"],
      ],
      imageResize: {
        handleStyles: {
          backgroundColor: " #212129",
          border: "none",
          color: "white"
        },
        modules: ["Resize", "DisplaySize"]
      }
    };
    
    const formats = [
      "header",
      "font",
      "bold",
      "italic",
      "underline",
      "strike",
      "blockquote",
      "align", // Ensure alignment format is registered
      "list",
      "bullet",
      "indent",
      "link",
      "image",
      "color"
    ];
  

  return (
    <Box className="text-editor" sx={{backgroundColor:"white", borderRadius: "5px", overflow: "hidden",border:"0.5px solid #CCCCCC" }}>
      <ReactQuill
        value={editorHtml}
        onChange={handleChange}
        placeholder={placeholder}
        modules={modules}
        formats={formats}
        style={{border:"none"}}
      />
    </Box>
  );
};

export default QuillEditor;
